import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardAppUser from "../../../assets/img/backgrounds/login_carousel_2-min.jpg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import SegmentUtils from "../../../lib/SegmentUtils";

const PLNPlusWelcomePage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(
    Capacitor?.isNativePlatform() ? true : false,
  );
  const pageRef = useRef();

  const [user, setUser] = useState<any>(null);

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    StorageUtils.get("user_customer").then((user) => {
      setUser(user);
    });
  }, []);

  const logout = async () => {
    await StorageUtils.clear();

    SegmentUtils.track("User Signout");

    const win: any = window;

    if (win?.posthog) {
      win?.posthog.reset();
    }

    if (nativeMode) {
      window.location.href = "/login";

      return;
    }

    if (Capacitor.isNativePlatform()) {
      OneSignal.logout();
    }

    history.push("/login");
  };

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : (
                <IonButtons slot="start">
                  <IonButton
                    color="dark"
                    onClick={() => {
                      logout();
                    }}
                    mode={
                      Capacitor.isNativePlatform()
                        ? Capacitor.getPlatform() == "ios"
                          ? "ios"
                          : "md"
                        : "ios"
                    }
                  >
                    Sign Out
                  </IonButton>
                </IonButtons>
              )}
              <IonTitle>Welcome To PLN</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={
            <>
              <IonButton
                fill="clear"
                className="pln-navbar-button ml-0"
                color="dark"
                expand="block"
                onClick={() => {
                  logout();
                }}
              >
                Logout
              </IonButton>
            </>
          }
          showMenuButton={false}
          pageName={"Welcome To PLN"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding pln-onboarding-container">
          <div className="text-center">
            <div className="rounded w-full min-h-[300px] max-h-[300px] max-w-[500px] mx-auto sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
              <img
                src={onboardAppUser}
                alt="App User"
                className="w-full shadow border h-full mx-auto max-h-[300px] rounded-2xl sm:max-h-[350px] object-cover"
              />
            </div>

            <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.5rem]">
              Welcome to Project LeanNation!
            </h2>

            <p className="max-w-[700px] mx-auto" style={{ fontSize: 18 }}>
              We make healthy living simple, delicious, and achievable with
              meals, coaching, and tools designed to help you thrive.
            </p>

            <div className="py-4">
              <div className="text-center text-2xl font-medium font-[SourceSerif]">
                What We Offer:
              </div>
              <div className="my-4 text-center p-3 border rounded-lg max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z" />
                      <path d="M6 17h12" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">
                  Chef-Crafted, Dietitian-Designed Meals
                </div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Healthy prepared meals tailored to your goals: whether it's
                  weight loss, muscle gain, or everyday clean eating.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-7 w-7 text-white"
                    >
                      <path d="m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8" />
                      <path d="M5 8h14" />
                      <path d="M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0" />
                      <path d="m12 8 1-6h2" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Protein Shakes & Supplements</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Convenient, high-quality options made to order that fuel
                  workouts and recovery.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white relative top-[1px]"
                    >
                      <path d="M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5" />
                      <path d="M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244" />
                      <path d="M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Grab & Go Meals & Snacks</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Quick meals, snacks, and drinks available in-store every day.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="m10 16 1.5 1.5" />
                      <path d="m14 8-1.5-1.5" />
                      <path d="M15 2c-1.798 1.998-2.518 3.995-2.807 5.993" />
                      <path d="m16.5 10.5 1 1" />
                      <path d="m17 6-2.891-2.891" />
                      <path d="M2 15c6.667-6 13.333 0 20-6" />
                      <path d="m20 9 .891.891" />
                      <path d="M3.109 14.109 4 15" />
                      <path d="m6.5 12.5 1 1" />
                      <path d="m7 18 2.891 2.891" />
                      <path d="M9 22c1.798-1.998 2.518-3.995 2.807-5.993" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Progress Tracking & InBody Scans</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  See your body composition and track results with cutting-edge
                  health tech.
                </div>
              </div>

              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M18 21a8 8 0 0 0-16 0" />
                      <circle cx="10" cy="8" r="5" />
                      <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Personal Coaching & Support</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Work with a dedicated coach for accountability, motivation,
                  and results-driven guidance.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M5 12h14" />
                      <path d="M12 5v14" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Everyday Value & Rewards</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Upgrade to a PLN+ membership to enjoy exclusive savings,
                  rewards, and more!
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          <IonButton
            onClick={() => {
              next();
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Continue
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default PLNPlusWelcomePage;
